var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useState, useEffect, createContext, useContext } from 'react';
import { getCurrencyRates } from '../services/currencyService';
export var availableCurrencies = ["ISK", "EUR", "USD", "GBP", "CAD"];
var CurrencyContext = createContext({
    currencyRates: null,
    selectedCurrency: null,
    languageCode: null
});
function CurrencyProvider(_a) {
    var _this = this;
    var children = _a.children, selectedCurrency = _a.selectedCurrency, languageCode = _a.languageCode, pageID = _a.pageID, defaultCurrency = _a.defaultCurrency, baseCurrency = _a.baseCurrency;
    var _b = useState(null), currencyRates = _b[0], setCurrencyRates = _b[1];
    useEffect(function () {
        var fetchCurrencyRates = function () { return __awaiter(_this, void 0, void 0, function () {
            var rates, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, getCurrencyRates()];
                    case 1:
                        rates = _a.sent();
                        setCurrencyRates(rates);
                        return [3 /*break*/, 3];
                    case 2:
                        error_1 = _a.sent();
                        console.error('Failed to fetch currency rates:', error_1);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        fetchCurrencyRates();
    }, []);
    useEffect(function () {
        var priceEls = document.querySelectorAll('.price:not(.exclude-convert)');
        if ((priceEls || "").length > 0) {
            // console.log("update prices in content here: ", selectedCurrency, languageCode, priceEls);
            priceEls.forEach(function (el) {
                var value = el.textContent;
                if (!value)
                    return;
                var originalValue = el.dataset.originalValue;
                if (originalValue == '' || originalValue == null || originalValue == undefined) {
                    var parsedValue = parseFloat(value.replace(',', ''));
                    el.dataset.originalValue = originalValue = String(parsedValue);
                }
                if (currencyRates && selectedCurrency && originalValue) {
                    var convertedPrice = getPriceInSelectedCurrency(currencyRates, parseFloat(originalValue), (baseCurrency || "isk").toLowerCase(), (selectedCurrency || "isk").toLowerCase()); //getPriceInSelectedCurrency(originalValue, "ISK", selectedCurrency);
                    el.textContent = formatPrice(convertedPrice, "en-US", selectedCurrency, 2);
                }
                else {
                    el.textContent = formatPrice(parseFloat(originalValue), "en-US", (baseCurrency || "isk").toLowerCase(), 2);
                }
            });
        }
    }, [selectedCurrency, languageCode, currencyRates, pageID]);
    return (React.createElement(CurrencyContext.Provider, { value: { currencyRates: currencyRates, selectedCurrency: selectedCurrency, languageCode: languageCode } }, children));
}
function CurrencyConverter(_a) {
    var price = _a.price, baseCurrency = _a.baseCurrency;
    var _b = useContext(CurrencyContext), currencyRates = _b.currencyRates, selectedCurrency = _b.selectedCurrency, languageCode = _b.languageCode;
    var _c = useState(null), convertedPrice = _c[0], setConvertedPrice = _c[1];
    useEffect(function () {
        var normalizedBaseCurrency = (baseCurrency || "isk").toLowerCase();
        var normalizedSelectedCurrency = (selectedCurrency || "isk").toLowerCase();
        if (normalizedBaseCurrency != normalizedSelectedCurrency && currencyRates && Object.keys(currencyRates).length > 0 && selectedCurrency) {
            //const conversionRate =
            //    currencyRates[normalizedSelectedCurrency] / currencyRates[normalizedBaseCurrency];
            var convertedPrice_1 = getPriceInSelectedCurrency(currencyRates, price, normalizedBaseCurrency, normalizedSelectedCurrency); //price * conversionRate;
            // console.log("set converted price: ", convertedPrice, price, normalizedBaseCurrency, normalizedSelectedCurrency);
            setConvertedPrice(convertedPrice_1);
        }
        else {
            setConvertedPrice(null);
        }
        // console.log("CurrencyConverter: ", price, convertedPrice, baseCurrency, selectedCurrency, currencyRates);
    }, [price, baseCurrency, selectedCurrency, currencyRates]);
    return React.createElement(React.Fragment, null, convertedPrice === null ? formatPrice(price, "en-US", (baseCurrency || "ISK"), 2) : formatPrice(convertedPrice, "en-US", selectedCurrency, 2));
}
function getPriceInSelectedCurrency(currencyRates, input, baseCurrency, targetCurrency) {
    if (baseCurrency != targetCurrency && !!currencyRates) {
        var conversionRate = currencyRates[targetCurrency] / currencyRates[baseCurrency];
        return input * conversionRate;
    }
    return input;
}
function formatPrice(input, culture, currency, minFractDigits) {
    var options = {
        style: "currency",
        currency: currency,
        minFractDigits: minFractDigits
    };
    return (Math.round((input || 0) * 100) / 100).toLocaleString(culture, options);
}
export { CurrencyProvider, CurrencyConverter };
